import { useTranslation } from "react-i18next";
import { MessagesSquare, Repeat, BookX, TimerOff } from "lucide-react";
import { useSectionView } from "@/hooks/use-section-view";

const ProblemSection = () => {
  const sectionRef = useSectionView<HTMLElement>("problem");
  const { t } = useTranslation();

  const problems = [
    {
      icon: MessagesSquare,
      titleKey: "problem.fragmentation.title",
      descKey: "problem.fragmentation.description",
    },
    {
      icon: Repeat,
      titleKey: "problem.productivity.title",
      descKey: "problem.productivity.description",
    },
    {
      icon: BookX,
      titleKey: "problem.costs.title",
      descKey: "problem.costs.description",
    },
    {
      icon: TimerOff,
      titleKey: "problem.complexity.title",
      descKey: "problem.complexity.description",
    },
  ];

  return (
    <section ref={sectionRef} className="py-20 lg:py-32 bg-gradient-to-br from-urgency/5 to-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            {t("problem.title")}{" "}
            <span className="text-urgency">{t("problem.titleHighlight")}</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            {t("problem.subtitle")}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {problems.map((problem, index) => {
            const Icon = problem.icon;
            return (
              <div
                key={index}
                className="group p-8 rounded-2xl bg-card border border-border hover:shadow-card hover:border-urgency/20 transition-all duration-300 animate-scale-in"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 rounded-xl bg-urgency/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Icon className="w-7 h-7 text-urgency" />
                </div>
                <h3 className="text-xl font-semibold mb-3">{t(problem.titleKey)}</h3>
                <p className="text-muted-foreground leading-relaxed">
                  {t(problem.descKey)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
